import { Text } from '@nimbus-ds/components';
import { InterfaceNameValue } from '@tiendanube/components';
import { CardWithTitle, InputNumber } from 'commons/components';
import Stack from 'commons/components/Stack';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import Skeleton from './Skeleton';

export interface CostAndDaysValuesInterface {
  additionalCost: number | string;
  additionalDays: number | string;
}

interface CostAndDaysCardProps extends CostAndDaysValuesInterface {
  onChange: (data: InterfaceNameValue) => void;
  errors?: Partial<Record<string, string>>;
}

function CostAndDaysCard({
  additionalCost,
  additionalDays,
  onChange,
  errors = {},
}: CostAndDaysCardProps): JSX.Element {
  const t = useTranslationShipping();

  const additionalCostValue = additionalCost !== 0 ? `${additionalCost}` : '';
  const additionalDaysValue = additionalDays !== 0 ? `${additionalDays}` : '';

  return (
    <CardWithTitle
      title={t('oca.config.costAndDays.title')}
      subtitle={t('oca.config.costAndDays.subtitle')}
    >
      <Stack column align="stretch">
        <Stack column spacing="tight" align="stretch">
          <InputNumber
            type="float"
            name="additionalCost"
            label={t('oca.config.costAndDays.additionalCost')}
            value={additionalCostValue}
            helpText={
              !errors.additionalCost
                ? t('oca.config.costAndDays.additionalCostSubline')
                : undefined
            }
            appearance={errors.additionalCost ? 'danger' : 'default'}
            onChange={onChange}
          />
          {!!errors.additionalCost && (
            <Text fontSize="caption" color="danger-textLow">
              {t(errors.additionalCost)}
            </Text>
          )}
        </Stack>

        <Stack column spacing="tight" align="stretch">
          <InputNumber
            type="integer"
            name="additionalDays"
            label={t('oca.config.costAndDays.additionalDays')}
            value={additionalDaysValue}
            helpText={
              !errors.additionalDays
                ? t('oca.config.costAndDays.additionalDaysSubline')
                : undefined
            }
            appearance={errors.additionalDays ? 'danger' : 'default'}
            onChange={onChange}
          />
          {!!errors.additionalDays && (
            <Text fontSize="caption" color="danger-textLow">
              {t(errors.additionalDays)}
            </Text>
          )}
        </Stack>
      </Stack>
    </CardWithTitle>
  );
}

CostAndDaysCard.Skeleton = Skeleton;

export default CostAndDaysCard;
